import { useStateMachine } from 'little-state-machine';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FormGroup } from '../../../../Components/FormGroup/FormGroup';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../../../_helpers/_methods';
import NavigationButtonGroup from '../../../admin/Events/Steps/components/NavigationButtonGroup';
import clearStore from '../clearStore';
import updateAction from '../updateAction';

function TraineeStep2() {
  const intl = useIntl();
  const { actions } = useStateMachine({ updateAction, clearStore });
  const { state } = useStateMachine({ updateAction });
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { id, edit: isEdit } = useParams();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    defaultValues: {}
  });
  const trainee = useSelector((state) => state.trainees.trainees);

  useEffect(() => {
    if (isEdit) {
      setValue('कैफियत', trainee?.remarks);
    }
  }, [trainee]);
  const onSubmit = async (data) => {
    actions.updateAction(data);
    try {
      const body = {
        username: state.email,
        password: 'password',
        email: state.email,
        phone: state.mobile_number,
        gender: state.trainee_gender.value,

        post: state.trainee_post,
        department: state.trainee_department,
        ethenicity: state?.trainee_caste_group?.id,

        // trainees address details
        fullname: state.fullname,
        province: state.trainees_address_physical_location_details.province.value,
        district: state.trainees_address_physical_location_details.district.value,
        municipality: state.trainees_address_physical_location_details.local_level.value,

        ward: state.trainees_address_physical_location_details.ward,
        tole: state.trainees_address_physical_location_details.tole,

        // trainees office details
        employee_type: Number(state.employee_type),
        office_name: state.office_name,
        departments: {
          address: {
            province: state.trainees_office_address_physical_location_details.province?.value,
            district: state.trainees_office_address_physical_location_details.district?.value,
            municipality:
              state.trainees_office_address_physical_location_details.local_level?.value,

            ward: state.trainees_office_address_physical_location_details.ward,
            tole: state.trainees_office_address_physical_location_details.tole
          }
        },
        office_address: {
          province: state.trainees_office_address_physical_location_details.province?.value,
          district: state.trainees_office_address_physical_location_details.district?.value,
          municipality: state.trainees_office_address_physical_location_details.local_level?.value,

          ward: state.trainees_office_address_physical_location_details?.ward,
          tole: state.trainees_office_address_physical_location_details?.tole
        },

        remarks: data.कैफियत
      };
      if (isEdit) {
        // trainee.old_office_address.id
        if (Array.isArray(trainee?.user?.address)) body.address_id = trainee.user.address[0].id;
        if (trainee?.old_office_address)
          body.departments.address.id = trainee.old_office_address.id;
        if (trainee?.old_office_address) body.office_address.id = trainee.old_office_address.id;
        setIsLoading(true);
        await fetchWrapper.patch(`/profile/participant/${id}/`, body);
        toast.success(intl.formatMessage({ id: 'participant_successful_update' }));

        actions.clearStore();
      } else {
        setIsLoading(true);
        await fetchWrapper.post('/profile/participant/', body);
        toast.success(intl.formatMessage({ id: 'participant_successful_creation' }));
        actions.clearStore();
      }

      let path = location.pathname;
      if (path.includes('admin')) {
        // send invitation email/sms
        // redirect to listing  page
        actions.clearStore();

        navigate(`/admin/users/trainees/list`);
      } else {
        navigate(`/instructions/trainee/${state.email}`);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error, 'error');
      setIsLoading(false);
      ErrorMessageHandler(error);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="step-1 py-3">
        <div className="row">
          <div className="col-md-12">
            <h3 className="my-2">
              <FormattedMessage id="remarks" />
            </h3>
            <div className="col-12">
              <FormattedMessage id="mention_remarks">
                {(placeholder) => (
                  <FormGroup
                    id="कैफियत"
                    type="textarea"
                    placeholder={placeholder[0]}
                    register={register}
                    defaultValue={state?.कैफियत}
                    error={errors}
                    label={<FormattedMessage id="mention_remarks" />}
                  />
                )}
              </FormattedMessage>
            </div>
          </div>
        </div>
      </div>
      <div className="registration-footer">
        <hr />

        <NavigationButtonGroup
          isSubmit={true}
          backTo={isEdit ? '/admin/users/trainees/list' : ''}
          isLoading={isLoading}
        />
      </div>
    </form>
  );
}

export default TraineeStep2;
